/**
 * @generated SignedSource<<eb679a5eea989c8872e5a71f9bf17319>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeasurementType = "BODYFAT" | "BODYWEIGHT" | "CALF" | "CHEST" | "HIP" | "SHOULDER" | "STEP_COUNT" | "THIGH" | "UPPER_ARM" | "WAIST" | "%future added value";
export type ClientMeasurementsCardQuery$variables = {
  measurementType?: MeasurementType | null | undefined;
};
export type ClientMeasurementsCardQuery$data = {
  readonly user: {
    readonly " $fragmentSpreads": FragmentRefs<"ClientMeasurementsCartDrawer_user">;
  } | null | undefined;
};
export type ClientMeasurementsCardQuery = {
  response: ClientMeasurementsCardQuery$data;
  variables: ClientMeasurementsCardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "measurementType"
  }
],
v1 = {
  "kind": "Variable",
  "name": "measurementType",
  "variableName": "measurementType"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientMeasurementsCardQuery",
    "selections": [
      {
        "alias": "user",
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ClientMeasurementsCartDrawer_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientMeasurementsCardQuery",
    "selections": [
      {
        "alias": "user",
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "units",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClientNutritionTarget",
            "kind": "LinkedField",
            "name": "nutritionTarget",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "trackingType",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "metricType",
                "value": "CHECKIN_ANSWER_MEASUREMENT"
              }
            ],
            "concreteType": "ClientMetric",
            "kind": "LinkedField",
            "name": "metrics",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "raw",
                    "value": true
                  }
                ],
                "kind": "ScalarField",
                "name": "activityDate",
                "storageKey": "activityDate(raw:true)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "value",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "measurement",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unit",
                        "storageKey": null
                      }
                    ],
                    "type": "CheckinAnswerMeasurementValue",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "60333b1bfae7049494d8a38e04b1ac29",
    "id": null,
    "metadata": {},
    "name": "ClientMeasurementsCardQuery",
    "operationKind": "query",
    "text": "query ClientMeasurementsCardQuery(\n  $measurementType: MeasurementType\n) {\n  user: me {\n    ...ClientMeasurementsCartDrawer_user_4m8Ydj\n    id\n  }\n}\n\nfragment ClientMeasurementsCartDrawerEditView_metrics on ClientMetric {\n  id\n  activityDate(raw: true)\n  name\n  value {\n    __typename\n    ... on CheckinAnswerMeasurementValue {\n      measurement\n      unit\n    }\n  }\n}\n\nfragment ClientMeasurementsCartDrawer_user_4m8Ydj on User {\n  id\n  units\n  nutritionTarget {\n    trackingType\n    id\n  }\n  metrics(metricType: CHECKIN_ANSWER_MEASUREMENT, measurementType: $measurementType) {\n    ...ClientMeasurementsCartDrawerEditView_metrics\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "feeb48f1cc6f921e8387b4e88c38fc79";

export default node;
